import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  Typography,
  TextField,
  Box,
  MenuItem,
  Select,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useNavigate, useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { useUser } from "../../../context/AuthContext";

const TopMenu = ({
  heading,
  setDrawerFilterOpen,
  filterApplied,
  searchQuery,
  setSearchQuery,
  setFilterValue,
  pageDirection,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState("Sent");
  const [filterValue, setFilterValueLocal] = useState("ALL");
  const [button, setButton] = useState("");
  const { user } = useUser();

  useEffect(() => {
    // const path = location.pathname;
    // if (path.includes("received")) {
    //   setSelectedOption("Received");
    //   setButton("Received");
    // } else if (path.includes("sent")) {
    //   setSelectedOption("Sent");
    //   setButton("Sent");
    // }
    setSelectedOption(pageDirection);
    setButton(pageDirection);
  }, [location]);

  const handleToggle = (option) => {
    setSelectedOption(option);
    setButton(option);

    // Navigate to the respective route
    if (option === "Sent") {
      navigate("/value-chain-request/sent");
    } else {
      navigate("/value-chain-request/received");
    }
  };

  const handleFilterChange = (event) => {
    const value = event.target.value;
    setFilterValueLocal(value);
    setFilterValue(value);
    console.log("Selected Filter:", value);
  };

  return (
    <Box sx={{ width: "100%", margin: "1rem 0" }}>
      {/* Title */}
      <Typography
        variant="h6"
        sx={{ fontWeight: "bold", color: "black", marginBottom: "1rem" }}
      >
        {heading}
      </Typography>

      {/* Search Bar and Filter Dropdown */}
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={10} md={4}>
          <TextField
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="🔍 Search"
            fullWidth
            size="small"
            variant="outlined"
            sx={{ backgroundColor: "#FFFFFF", borderRadius: "4px" }}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={8}
          sx={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}
        >
          <Button
            variant="contained"
            onClick={() => setDrawerFilterOpen(true)}
            sx={{
              backgroundColor: "#FFFFFF",
              color: "black",
              textTransform: "none",
              "&:hover": { backgroundColor: "#1C486B", color: "#FFFFFF" },
            }}
          >
            FILTER
            <FilterListIcon />
            {filterApplied && (
              <FiberManualRecordIcon
                className="dot-icon"
                sx={{ fontSize: "10px", color: "#488257", marginLeft: "5px" }}
              />
            )}
          </Button>
        </Grid>
      </Grid>

      {/* Sent and Received Buttons */}
      <Grid
        container
        sx={{
          marginTop: "1rem",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Grid item sx={{ display: "flex", gap: "1rem" }}>
          {!user?.companyAdmin ? (
            <Button
              variant={button === "Sent" ? "contained" : "outlined"}
              // onClick={() => handleToggle("Sent")}
              sx={{
                backgroundColor: button === "Sent" ? "#1C486B" : "#ededed",
                color: button === "Sent" ? "#ededed" : "#1C486B",
                borderColor: "#1C486B",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: button === "Sent" ? "#123A55" : "#F0F8FF",
                },
              }}
            >
              Sent
            </Button>
          ) : (
            <Button
              variant={button === "Received" ? "contained" : "outlined"}
              // onClick={() => handleToggle("Received")}
              sx={{
                backgroundColor: button === "Received" ? "#1C486B" : "#ededed",
                color: button === "Received" ? "#ededed" : "#1C486B",
                borderColor: "#1C486B",
                textTransform: "none",
                "&:hover": {
                  backgroundColor:
                    button === "Received" ? "#123A55" : "#F0F8FF",
                },
              }}
            >
              Received
            </Button>
          )}
        </Grid>
        <Grid item>
          <Select
            value={filterValue}
            onChange={handleFilterChange}
            variant="outlined"
            size="small"
            sx={{
              backgroundColor: "#FFFFFF",
              color: "#1C486B",
              textTransform: "none",
              width: "140px",
              border: "none",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
              "&:hover": { boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)" },
              "& .MuiOutlinedInput-notchedOutline": { display: "none" },
            }}
          >
            <MenuItem value="ALL">ALL</MenuItem>
            <MenuItem value="Upstream">Upstream</MenuItem>
            <MenuItem value="Downstream">Downstream</MenuItem>
          </Select>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TopMenu;
